import React, { Component }	from "react";
import { withRouter }		from "react-router";
import { connect }			from "react-redux";
import classNames			from "classnames";

import {
	closeRoleForm,
	saveRoleRequest,
	deleteRoleRequest
} from "./rolesActions";

import { getRoleSelector }			from "../../reducers/roles";
import {
	getIsRoleFormOpenSelector,
	getActiveRoleIdSelector
}									from "../../reducers/app";

import RoleForm				from "./RoleForm";
import RoleFormConfirmation	from "./RoleFormConfirmation";

import Icon from "../../common/components/Icon";

const initialState = {
	role_id			: null,
	name			: "",
	number_of_keys	: 1,
	isConfirmationOpen: false
};

class RoleFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...initialState
		};
		this.handleFieldChange	= this.handleFieldChange.bind(this);
		this.openConfirmation	= this.openConfirmation.bind(this);
		this.closeConfirmation	= this.closeConfirmation.bind(this);
		this.handleDelete		= this.handleDelete.bind(this);
		this.handleSubmit		= this.handleSubmit.bind(this);
		this.resetForm			= this.resetForm.bind(this);
	}

	componentDidMount() {
		if(this.props.role) {
			this.setState({ ...this.props.role });
		}
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.role) {
			this.setState({ ...nextProps.role });
			return;
		}

		this.resetForm();
	}

	render() {
		if(!this.props.isOpen) {
			return null;
		}

		const wrapperClasses = classNames({
			'u-flex--col' : true,
			'c-role-form-wrapper' : true,
		})

		return (
			<div className={wrapperClasses}>
				<RoleForm
					roleId={this.state.role_id}
					name={this.state.name}
					number_of_keys={this.state.number_of_keys}
					onFieldChange={this.handleFieldChange}
					onDelete={this.openConfirmation}
					onSubmit={this.handleSubmit} />
				<RoleFormConfirmation
					name={this.state.name}
					isOpen={this.state.isConfirmationOpen}
					onCancel={this.closeConfirmation}
					onConfirm={this.handleDelete} />
				<div className="mask u-height100 u-text-right" onClick={this.props.closeRoleForm}>
					<button className="m-1 u-cursor-pointer">
						<Icon icon="cancel" size="large" color="white" />
					</button>
				</div>
			</div>
		);
	}

	handleFieldChange(field, value) {
		this.setState({ [field]: value });
	}

	openConfirmation(event) {
		event.preventDefault();
		this.setState({ isConfirmationOpen: true });
	}

	closeConfirmation() {
		this.setState({ isConfirmationOpen: false });
	}

	handleDelete(event) {
		event.preventDefault();
		this.props.deleteRoleRequest(this.state.role_id)
	}

	handleSubmit(event) {
		const fields = {
			name: this.state.name,
			number_of_keys: this.state.number_of_keys
		};
		this.props.saveRoleRequest(
			this.state.role_id,
			fields
		)
	}

	resetForm() {
		this.setState({ ...initialState });
	}
}

function mapStateToProps(state) {
	const activeRoleId = getActiveRoleIdSelector(state);
	return {
		isOpen: getIsRoleFormOpenSelector(state),
		role: getRoleSelector(state)(activeRoleId)
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		closeRoleForm: () => {
			dispatch(
				closeRoleForm()
			);
		},
		saveRoleRequest: (roleId, fields) => {
			dispatch(
				saveRoleRequest(projectId, roleId, fields)
			);
		},
		deleteRoleRequest: (roleId) => {
			dispatch(
				deleteRoleRequest(projectId, roleId)
			);
		}
	};
}

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	) (RoleFormContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/roles/RoleFormContainer.js